var _metadata;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlnsX: "&ns_extend;",
    xmlnsI: "&ns_ai;",
    xmlnsGraph: "&ns_graphs;",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150.5 36",
    style: {
      enableBackground: "new 0 0 150.5 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "&ns_sfw;"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    bottomLeftOrigin: "true",
    height: 32.4,
    width: 149.6,
    x: 0.4,
    y: -34.2
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 65.8526,
    y1: 11.3829,
    x2: 71.7359,
    y2: 34.5483
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F75023"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D73421"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M66.1,33.2c-1.4-0.1-1.5-5.5-1.6-7.3c-0.1-1.7-0.7-16.2-0.7-16.2l7.6,0.5 c0,0,1.1,19.4,0.7,20.4C71.8,31.6,71.2,33.7,66.1,33.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.7153,
    y1: 6.9777,
    x2: 20.7523,
    y2: 39.1519
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#872999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#432B89"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M1,32.4c-0.4-0.9,2.4-9.2,4.8-16.5C7.4,11,9,6.3,9.8,5.6c2.2-1.8,7.7-1.5,8.8-0.7 S29.7,31,29,32.4c-0.7,1.5-5.9,1.8-7,1.5c-0.6-0.2-2.4-8-4.4-14.3c-1.5-4.8-3.3-8.5-3.3-8.5s-1.5,4.6-2.9,9.9 c-1.6,5.9-3.1,12.5-3.7,12.9C6.5,34.6,1.8,33.9,1,32.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.9629,
    y1: 19.8795,
    x2: 20.1779,
    y2: 13.077
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#872499"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#432B89"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    d: "M14.2,11.2c-0.6-1.4-1.9-4.5-3.1-4.8c-0.9-0.3-1.5-0.1-1.9,0.2C8.3,8.3,7.1,12,5.8,15.9 C3.4,23.2,0.6,31.5,1,32.4c0.7,1.5,5.5,2.2,6.6,1.5c0.6-0.4,2.1-7,3.7-12.9C12.6,16.1,14,11.8,14.2,11.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 8.2573,
    y1: 14.5572,
    x2: 24.9266,
    y2: 38.9483
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#892899"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#432B89"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    d: "M0.8,21.9c-0.6,0.3-0.2,4.6-0.2,4.9s0.8,0.8,1.3,0.9c0.6,0.1,7.6,0.7,13.7,0.7 s11.7-0.7,12.7-0.8c1-0.1,1.3-1,1.4-1.3c0.1-0.3-0.1-3.8-0.4-4.4c-0.3-0.6-1.6-0.6-2.1-0.6s-7.5,0.9-12.5,0.7 c-5-0.2-11-0.4-11.8-0.4C2.2,21.5,1.4,21.5,0.8,21.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.7757,
    y1: 39.7086,
    x2: 113.5383,
    y2: 5.5121
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FAD33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6C137"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_5_)"
    },
    d: "M109.5,32.4c-0.4-0.9,2.4-9.2,4.8-16.5c1.6-4.9,3.2-9.6,4-10.3c2.2-1.8,7.7-1.5,8.8-0.7 c1.1,0.7,11,26.1,10.3,27.6c-0.7,1.5-5.9,1.8-7,1.5c-0.6-0.2-2.4-8-4.4-14.3c-1.5-4.8-3.3-8.5-3.3-8.5s-1.5,4.6-2.9,9.9 c-1.6,5.9-3.1,12.5-3.7,12.9C115,34.6,110.2,33.9,109.5,32.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.1686,
    y1: 9.8461,
    x2: 111.4468,
    y2: 38.4045
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FAD33A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6C137"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_6_)"
    },
    d: "M119.1,6.1c-0.5-0.2-0.8-0.2-1.1-0.1c-0.9,1.4-2.3,5.5-3.7,9.9c-2.4,7.3-5.2,15.7-4.8,16.5 c0.7,1.5,5.5,2.2,6.6,1.5c0.6-0.4,2.1-7,3.7-12.9c1.4-5,2.8-9.5,2.9-9.9C122.1,8.8,120.2,6.5,119.1,6.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 97.0886,
    y1: 21.8795,
    x2: 102.788,
    y2: 22.2472
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FB8D2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F97523"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_7_)"
    },
    d: "M94.8,10.7c0.1,0.5-0.2,11.6,0,14.8s0.2,6.9,0.5,7.4s0.5,0.9,1.7,1c1.3,0.1,4.7,0.1,5.3-0.1 c0.6-0.2,0.9-0.3,0.9-0.7c0.1-0.4-0.5-15.6-0.4-18.3c0.1-2.7,0.1-4.5,0.1-4.5L94.8,10.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.0451,
    y1: 5.1117,
    x2: 99.4128,
    y2: 12.3736
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FB8D2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F97523"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_8_)"
    },
    d: "M87.7,11c0.2,0.4,0.8,0.8,1.6,0.7c1.5,0,4-0.4,6.8-0.4c4.2,0,11.7,0.3,13.1,0.4 c1.5,0.1,1.7-0.7,1.7-1.6c0-0.9,0.1-3.4,0-4.2c-0.2-1.1-1.3-1.2-2.2-1.2c-1,0-17.9,0-18.8,0c-0.9,0.1-1.8,0.9-2.2,2 S87.3,10.2,87.7,11z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 61.187,
    y1: 8.1985,
    x2: 85.72,
    y2: 8.1985
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F75023"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D73421"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_9_)"
    },
    d: "M61.2,10.7c0,0.3,0.3,1.1,1.3,1.2c1.1,0.1,21.7-0.3,22.2-0.4c0.5-0.1,1-0.6,1-1.1 c0-0.6-0.1-4.5-0.2-4.9c-0.3-0.8-1.2-0.9-2.9-1c-1.7-0.1-18.3,0.6-19.4,0.7c-1,0.1-1.6,0.7-1.8,1.6C61.1,7.6,61.2,10.2,61.2,10.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 61.2638,
    y1: 20.4398,
    x2: 87.0683,
    y2: 20.4398
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F75023"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D73421"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_10_)"
    },
    d: "M61.3,18.7v3.5c0,0-0.1,1.2,1.2,1.3c1.4,0.1,22.2,0,22.7,0s1.7-0.1,1.8-1.5 c0.1-1.4,0-2.7,0-3.1s0.1-1.5-2.2-1.6c-2.3-0.1-19.9-0.1-21.3,0C62.2,17.4,61.5,18,61.3,18.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 64.2972,
    y1: 30.3953,
    x2: 85.3009,
    y2: 30.3953
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F75023"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D73421"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_11_)"
    },
    d: "M64.3,30.5c0-0.8,0.1-1.7,0.6-2.3c0.5-0.6,1.3-0.6,2.6-0.6c1.3,0,16.4-0.5,16.9-0.4 c0.6,0.1,0.8,1.1,0.8,1.6s0.4,3.2-0.4,4c-0.8,0.7-3.6,0.7-5.1,0.7c-1.5,0-13.3,0-13.9,0S64.2,32.9,64.3,30.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.2888,
    y1: 17.246,
    x2: 66.5709,
    y2: 15.4688
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DA4378"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B04A9E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_12_)"
    },
    d: "M37,2.1c-0.4-0.4-1.1-0.4-1.7-0.1c-0.5,0.3-4.8,3.1-5.1,3.9c-0.3,0.7-0.1,1.6,0.7,2.5 s5,6.5,6.5,8.5c1.5,2,10.8,13.9,12,15.1c1.2,1.2,1.7,1.3,2,1.3s3.7,0.3,4.6,0s1-0.8,1.1-1.4c0.1-0.6,1-14,0.9-18.1s0.2-8.3,0-8.8 s-0.8-0.6-1.6-0.7c-0.6-0.1-4.5,0-5.1,0.3c-0.6,0.3-0.6,1.2-0.6,1.4s-0.1,15.1-0.1,15.1S37.7,2.8,37,2.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 33.1606,
    y1: 20.9943,
    x2: 57.184,
    y2: 21.4233
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DA4378"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0841271,
    style: {
      stopColor: "#D4437D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1923,
    style: {
      stopColor: "#C44489"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    style: {
      stopColor: "#AA449F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4019,
    style: {
      stopColor: "#9245B2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_13_)"
    },
    d: "M33.4,32.5c0.2,0.4,0.6,0.8,1.2,0.9c0.7,0,4-0.1,4.7-0.3c0.7-0.2,1.1-0.8,1.1-1.7 s-1.2-12.8-1.3-14c-5.2-5.4-7.2-8.7-7.2-8.7s0.6,14.2,0.7,16.8C32.9,28,33.2,32,33.4,32.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.9908,
    y1: 16.9961,
    x2: 52.3254,
    y2: 11.1741
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DA4378"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1453,
    style: {
      stopColor: "#B64495"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2797,
    style: {
      stopColor: "#9C45AA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3593,
    style: {
      stopColor: "#9245B2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_14_)"
    },
    d: "M51.1,33.2c-0.3-3.3-0.5-8.6-0.6-12.2C49.8,20.1,37.7,2.8,37,2.1c-0.4-0.4-1.1-0.4-1.7-0.1 c-0.5,0.3-4.8,3.1-5.1,3.9c-0.3,0.7-0.1,1.6,0.7,2.5c0.8,0.9,5,6.5,6.5,8.5c1.5,2,10.8,13.9,12,15.1C50.3,32.8,50.7,33.1,51.1,33.2 z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_15_",
    cx: 14.3393,
    cy: 3.4612,
    r: 5.5347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "url(#SVGID_15_)"
    },
    d: "M11,5.4c0,0,6-0.2,7-0.1C15,4.4,11,5.4,11,5.4z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_16_",
    cx: 13.512,
    cy: 21.203,
    r: 12.5502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "url(#SVGID_16_)"
    },
    d: "M1.3,22.5c0,0,7.7,0.7,14.4,0.5c6.7-0.2,12.5-0.8,12.5-0.8s-9.5,0.4-13.3,0.4 S1.3,22.5,1.3,22.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 155.2878,
    y1: 23.9002,
    x2: 99.7644,
    y2: 25.5548
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85D5F0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#40BBE4"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_17_)"
    },
    d: "M100.1,18.9c0,0,0.8,4.3,2.5,5.8c-1.7,1.9-2.8,5.9-2.8,5.9s11,0.2,12.2-0.1 c1.1-0.3,1.8-1.9,1.8-1.9s23.9-0.2,24.3-0.3c-0.9,1-2.5,2.2-2.4,2.5c0.1,0.4,2,2.7,2.8,2.8c0.7,0.1,11.4-7.8,11.6-8.1 c0.1-0.3,0-2.6-0.1-2.8c-0.1-0.2-9.3-5.6-12.4-7.1c-0.5-0.3-0.7-0.3-0.8-0.2c-0.5,0.2-1.8,2.8-1.5,3.4c0.1,0.2,0.6,0.5,1.2,1 c0.8,0.6,1.6,1.3,1.6,1.3l-23.9,0.3c0,0-1.2-1.8-2.2-2.1C110.9,19,100.1,18.9,100.1,18.9z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_18_",
    cx: 51.4775,
    cy: 11.9184,
    r: 18.171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "url(#SVGID_18_)"
    },
    d: "M51.4,5.4c0,0-0.1,11.4,0,14s0.2,12.3,0.2,12.3s0.4-10.4,0.3-13.2 S51.4,5.4,51.4,5.4z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_19_",
    cx: 42.8365,
    cy: 10.2637,
    r: 15.7024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "url(#SVGID_19_)"
    },
    d: "M36.4,2.8c0,0,5,7.1,7.6,11.1c2.8,4.3,5.6,7.5,5.6,7.5s-3.5-5.1-6.5-9.5 C40.1,7.4,36.4,2.8,36.4,2.8z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_20_",
    cx: 33.46,
    cy: 14.4924,
    r: 17.4544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "url(#SVGID_20_)"
    },
    d: "M33.9,32c0,0-0.2-6.1-0.3-9.2c-0.1-3.1-0.5-10.1-0.5-10.1s0.1,8.2,0.2,10.7 C33.4,26.6,33.9,32,33.9,32z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.7847,
    y1: 28.5954,
    x2: 150.0596,
    y2: 28.5954
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A5E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5CC2EA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_21_)"
    },
    d: "M150,25.4c0.1-0.1,0.1-0.6,0.1-1.1c-2,0.1-4.1-0.3-7.8-0.6c-4.8-0.4-7.2,0-10.7,0.3 c-3.6,0.3-6,1.1-10.8,1.5c-4.8,0.4-12.1,0.2-15-0.2c-1.5-0.3-2.6-0.5-3.3-0.7c0,0,0,0,0.1,0.1c-1.7,1.9-2.8,5.9-2.8,5.9 s11,0.2,12.2-0.1c1.1-0.3,1.8-1.9,1.8-1.9s23.9-0.2,24.3-0.3c-0.9,1-2.5,2.2-2.4,2.5c0.1,0.4,2,2.7,2.8,2.8 C139.2,33.7,149.9,25.8,150,25.4z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.34,
      fill: "#FFFFFF"
    },
    d: "M62.2,5.9c3.6-0.3,17.7-0.7,22.4-0.8C82.6,4.8,64.9,5,62.2,5.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.1508,
    y1: 15.0514,
    x2: 73.967,
    y2: 20.4291
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "url(#SVGID_22_)"
    },
    d: "M62.1,18.2c3.4-0.2,22.2,0,23.8-0.2C85.8,17.7,70.1,17.3,62.1,18.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 78.4134,
    y1: 27.9569,
    x2: 64.4406,
    y2: 28.1407
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "url(#SVGID_23_)"
    },
    d: "M65.7,28.3c3.5,0.3,17.3-0.3,18.7-0.4C84.4,27.3,67.7,28,65.7,28.3z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_24_",
    cx: 99.62,
    cy: 5.1688,
    r: 7.3501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "url(#SVGID_24_)"
    },
    d: "M89.2,5.4c2.3-0.2,16.4-0.3,20.8-0.1C108.3,4.6,90.8,5,89.2,5.4z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_25_",
    cx: 95.6634,
    cy: 22.398,
    r: 10.4206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "url(#SVGID_25_)"
    },
    d: "M95.6,12.1c0,2.2-0.1,12.6,0,20.2C95.2,30.7,95.1,12.7,95.6,12.1z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_26_",
    cx: 124.1911,
    cy: 21.6932,
    r: 17.6499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "url(#SVGID_26_)"
    },
    d: "M114.1,22c6.6,0,23.3-0.3,23.8-0.4C136.3,21.3,125,21.2,114.1,22z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_27_",
    cx: 122.5978,
    cy: 4.1047,
    r: 6.4442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "url(#SVGID_27_)"
    },
    d: "M119.1,5.4c1.6-0.3,6.5-0.3,7.4-0.4C126.3,4.4,119.2,4.7,119.1,5.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9bb7dcfbfb7d34401c4050cbd2d66634.svg";
export { ForwardRef as ReactComponent };